export const STAGING_BASE_URL = "https://staging-api.ankota.net/fms";
export const STAGING_INTEGRATION_URL = "https://staging-api.ankota.net/integrations";
export const STAGING_PATIENT_URL = "https://staging-api.ankota.net/patients";
export const PRODUCTION_BASE_URL = "https://api.ankota.net/fms";
export const DEVELOPMENT_BASE_URL = "https://ankota-be.redcoastgroup.com";
export const STAGING_URL = "https://staging-api.ankota.net";

// Determine environment based on ?env= query parameter
const urlParams = new URLSearchParams(window.location.search);
const envParam = (urlParams.get('env') || urlParams.get('environment') || '').toLowerCase();

// Determine staging vs production
const hostname = window.location.hostname;
const referrer = document.referrer || '';
const isEmbeddedInAnkota = referrer.includes('ankota.net');

// When embedded in ankota.net, use referrer to decide:
//   ankota.net/Staging/... → staging, ankota.net/web/... → prod
// When accessed directly (not embedded): localhost, web.app → staging.
// spending-plan.ankota.net is the real public production URL, so it is NOT treated as staging.
const isStaging = envParam === 'staging' ||
                  hostname === 'localhost' ||
                  (isEmbeddedInAnkota
                    ? (referrer.includes('/Staging/') || referrer.includes('/staging/'))
                    : hostname === 'fms-spending-plan.web.app');

export const BASE_URL = isStaging ? STAGING_BASE_URL : PRODUCTION_BASE_URL;

export const isLocalhost = hostname === 'localhost' || hostname === '127.0.0.1';

const isAnkotaUrl = (url) => {
    try {
        const host = new URL(url).hostname.toLowerCase();
        return host === 'ankota.net' || host.endsWith('.ankota.net');
    } catch {
        return false;
    }
};

// True only when running inside an iframe whose parent page is on ankota.net.
// ancestorOrigins is set by the browser (the parent page can't fake it); Firefox lacks it,
// so fall back to the referrer there. Hostnames are parsed, not substring-matched.
export const isEmbeddedInAnkotaParent = (() => {
    if (window.self === window.top) return false;
    const ancestors = window.location.ancestorOrigins;
    if (ancestors && ancestors.length > 0) return isAnkotaUrl(ancestors[0]);
    return isAnkotaUrl(referrer);
})();